<div [ngClass]="customClass">
  {{ data || defaultValue }}
</div>
